import { useCallback } from "react";
import { isInMap, setToMap } from "../../lib/hashmap";
import { products_shop_collections_products } from "../../__generated__/products";

const useSorting = (
  slug: string,
  products: products_shop_collections_products[]
): products_shop_collections_products[] => {
  const sortingList: Map<string, products_shop_collections_products[]> =
    new Map([
      ["pizza", []],
      ["sets", []],
      ["pechenyj-kartofel", []],
      ["french-fries", []],
      ["barbecue", []],
      ["mangalgril", []],
      ["lapsha-wok", []],
      ["rolls", []],
      ["pancakes", []],
      ["desserts", []],
      ["others", []],
    ]);

  const sortPopularProducts = () => {
    products?.map((product) => {
      let isFindOnce = false;
      const collections = product?.collections;

      collections?.map(({ slug }) => {
        if (!isInMap(sortingList, slug) || isFindOnce) return;
        isFindOnce = true;
        setToMap(sortingList, slug, product);
      });

      if (!isFindOnce) setToMap(sortingList, "others", product);
    });
  };

  const memoizedSortPopularPorudcts = useCallback(sortPopularProducts, [
    products,
  ]);

  memoizedSortPopularPorudcts();

  if (slug !== "popular" || !products) return products;

  const combinedSortedCollection = [...sortingList.values()].flat();

  return combinedSortedCollection;
};

export default useSorting;
